export default "__VITE_ASSET__e48af4e4__"